export function getLinkFoto(linkFoto) {
  if (linkFoto) return linkFoto.replace('https://s3.amazonaws.com/infoprice-prd-repository', 'https://d1kkb7tj44tam6.cloudfront.net');
  return '';
}

export function getFotoDownload(item) {
  if (item['BiDesagregado.tipoColeta'] === 'PP') {
    return getLinkFoto(item['BiDesagregado.linkFotoSugestao']);
  }
  return getLinkFoto(item['BiDesagregado.linkFoto']);
}
